import { useEffect, useRef } from 'react'
import { useDesignMode } from '@/features/designMode/designModeStore'
import { useDesignPreviewProjectId } from '@/features/designMode/designPreviewProjectStore'
import {
  getDesignModePreviewForProject,
  getDesignModeThreadForProject,
} from '@/features/designMode/designModeProjectConfig'
import { resetDesignPreviewTab } from '@/features/designMode/designPreviewTabStore'
import { useDocumentPreview } from '@/features/documentPreview/useDocumentPreview'
import { useAppShellLayoutContext } from './AppShellLayoutContext.jsx'

/**
 * Reacts to Design mode toggling and project selection: opens the project
 * thread with the matching preview artifact, and closes the preview on exit.
 */
export default function DesignModeController() {
  const designMode = useDesignMode()
  const projectId = useDesignPreviewProjectId()
  const { openPreview, closePreview, activeArtifact } = useDocumentPreview()
  const layout = useAppShellLayoutContext()
  const onThreadSelect = layout?.secondaryNavProps?.onThreadSelect
  const prevDesignModeRef = useRef(designMode)

  useEffect(() => {
    if (!designMode) {
      if (prevDesignModeRef.current) {
        resetDesignPreviewTab()
        closePreview()
      }
      prevDesignModeRef.current = designMode
      return
    }

    prevDesignModeRef.current = designMode
    const thread = getDesignModeThreadForProject(projectId)
    onThreadSelect?.(thread)
    openPreview(getDesignModePreviewForProject(projectId))
  }, [designMode, projectId, onThreadSelect, openPreview, closePreview])

  useEffect(() => {
    if (!designMode || activeArtifact) return
    openPreview(getDesignModePreviewForProject(projectId))
  }, [designMode, activeArtifact, projectId, openPreview])

  return null
}
